import SseHub from './SseHub.js';

// Cliente SSE para la narración del progreso de la generación masiva de items enriquecidos.
// Singleton de módulo: la conexión sobrevive a la navegación, así que avisa al terminar
// (o si hay error) aunque el usuario se haya ido a otra pantalla.

const subscribers = [];
let enganchado = false;
const CANAL = 'generacion-items';
let f7ref = null;
let ultimoResumen = null;

function notify(payload) {
    subscribers.slice().forEach(function (cb) {
        try { cb(payload); } catch (err) { console.error('GeneracionItemsEvents subscriber threw', err); }
    });
}

function toastGlobal(texto) {
    try {
        if (f7ref && f7ref.toast) {
            f7ref.toast.create({ text: texto, closeTimeout: 5000, closeButton: true }).open();
        }
    } catch (e) {}
}

function onEvento(evento) {
    // El hub entrega el payload ya deserializado (antes llegaba el evento SSE crudo). Se
    // admite tambien una cadena por si algun emisor mandara texto plano.
    let payload = evento;
    if (typeof evento === 'string') {
        try { payload = JSON.parse(evento); } catch (err) { payload = evento; }
    }
    if (payload && payload.estado === 'fin') {
        ultimoResumen = payload.resumen || null;
        toastGlobal('✅ ' + (payload.texto || 'Generación terminada.'));
    } else if (payload && payload.estado === 'cancelado') {
        toastGlobal('⏹️ ' + (payload.texto || 'Generación cancelada.'));
    } else if (payload && payload.estado === 'error') {
        toastGlobal('⚠️ ' + (payload.latin || 'Error') + ' — ' + (payload.texto || 'Error en la generación.'));
    }
    notify(payload);
}

function ensureConnected() {
    if (enganchado) return;
    enganchado = true;
    // Ya no se abre una conexion propia: el hub trae TODOS los canales por un unico stream
    // (el navegador solo admite ~6 por origen en HTTP/1.1 y la app tiene 8 canales).
    SseHub.subscribe(CANAL, onEvento);
}

export default {
    subscribe(callback, f7) {
        if (f7) f7ref = f7;
        if (typeof callback === 'function' && subscribers.indexOf(callback) < 0) {
            subscribers.push(callback);
        }
        ensureConnected();
    },
    unsubscribe(callback) {
        const i = subscribers.indexOf(callback);
        if (i >= 0) subscribers.splice(i, 1);
        // Sin suscriptores no tiene sentido retener la conexión: en HTTP/1.1 local cada
        // stream SSE consume una de las ~6 conexiones por host y acumula pestañas colgadas.
        if (!subscribers.length) this.close();
    },
    close() {
        // La conexion es unica y compartida por todos los canales: aqui solo nos desenganchamos.
        if (enganchado) {
            SseHub.unsubscribe(CANAL, onEvento);
            enganchado = false;
        }
    },
    ultimoResumen() { return ultimoResumen; }
};
